var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCadastro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_487_1031)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 18C25.2386 18 23 20.2386 23 23C23 25.7615 25.2386 28 28 28C30.7615 28 33 25.7614 33 23C33 20.2386 30.7615 18 28 18ZM25 23C25 21.3432 26.3432 20 28 20C29.6569 20 31 21.3431 31 23C31 24.6569 29.6569 26 28 26C26.3431 26 25 24.6569 25 23ZM20 35.4C20 33.5222 21.5222 32 23.4 32H32.6C34.4778 32 36 33.5222 36 35.4C36 35.7314 35.7314 36 35.4 36H20.6C20.2686 36 20 35.7314 20 35.4ZM23.4 30C20.4177 30 18 32.4177 18 35.4C18 36.8359 19.1641 38 20.6 38H35.4C36.8359 38 38 36.8359 38 35.4C38 32.4177 35.5823 30 32.6 30H23.4Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_487_1031",
    x1: 0,
    y1: 28,
    x2: 56,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF914C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadastro);
export default __webpack_public_path__ + "static/media/cadastro.e53b02532f0ba1883bbdc9bd99c4f652.svg";
export { ForwardRef as ReactComponent };